module.exports = __webpack_public_path__ + "static/media/h5_banner_2.ab909b27.png";